var maskSmall = "/static/5bad464392a23581.png";

export { maskSmall as default };
//# sourceMappingURL=mask-sm.png.js.map
